import { css } from 'lit';

export const agreementViewStyles = css`

  view-content {
    padding-top: 6rem;
  }

  h1 {
    font-size: 1.5rem;
    line-height: 1.3em;
    margin: 0;
  }
  h2 {
    font-size: 1.4rem;
    line-height: 1.3em;
  }

  header-bar {
    gap: 2rem;
  }

  notice-panel .inner {
    max-width: none;
    width: 100%;
    padding: 5rem 1.5rem;
  }

  sl-button[variant='text']::part(base) {
    color: var(--gray-6);
    padding-left: 0;
    font-weight: 200;
  }

  zero-md {
    border-radius: 12px;
    box-shadow: var(--sl-shadow-small);
    margin: 0 -1.5rem;
    font-size: 0.875rem;

    --highlight-background: var(--yellow-1);
    --highlight-color: var(--yellow-9);
  }
  zero-md.declined {
    --highlight-background: var(--red-1) !important;
    --highlight-color: var(--red-8) !important;
  }
  @media(min-width: 650px) {
    zero-md {
      margin: 0;
      font-size: 0.9rem;
    }
  }
  @media(min-width: 1000px) {
    zero-md {
      margin: 0;
      font-size: 1rem;
    }
  }

  scroll-fab {
    position: fixed;
    left: calc(50vw - 3rem);
    right: calc(50vw - 3rem);

    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 50;
  }
  scroll-fab.up { top: 70px; }
  scroll-fab.down { bottom: 50px; }
  
  scroll-fab sl-button {
    transform: scale(1);
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }
  scroll-fab sl-button[disabled] {
    transform: scale(0);
    opacity: 0;
  }
  scroll-fab sl-button::part(base) {
    box-shadow: var(--sl-shadow-large);
    background: var(--gray-8);
    border-color: var(--gray-5);
  }

  response-footer {
    display: block;
    background: var(--yellow-2);
    border: 1px solid var(--yellow-1);
    border-radius: 12px;
    margin: -2rem -2rem 0 -2rem;
  }

  response-footer .inner {
    display: block;
    position: relative;

    margin: var(--rfi-margin);
    padding: var(--rfi-gutters);
    padding-bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid var(--yellow-3);
    border-radius: 7px;
    box-shadow: var(--sl-shadow-medium);

    --rfi-gutters: 1.5rem;
    --rfi-margin: 3rem 1.5rem;
  }
  @media(min-width: 650px) {
    response-footer .inner {
      --rfi-margin: 4rem 2rem;
      --rfi-gutters: 2rem;
    }
  }
  @media(min-width: 1000px) {
    response-footer .inner {
      --rfi-margin: 4rem;
      --rfi-gutters: 3rem;
    }
  }

  response-footer .subtitle {
    font-weight: 200;
    margin-top: 0 !important;
    line-height: 1.5em;

    --link-color-default: var(--gray-8);
    --link-color-visited: var(--gray-8);
    --link-font-weight-default: 200;
    --link-color-focus: var(--gray-9);
    --link-font-weight-focus: 500;
  }

  response-footer button-bar {
    display: flex;
    justify-content: space-between;
    margin: 0 calc(-1 * var(--rfi-gutters));
    margin-top: calc(2 * var(--rfi-gutters));
    padding: var(--rfi-gutters);
    background: rgba(255, 255, 255, 0.8);
    border-top: 1px solid var(--yellow-2);
  }
  @media(min-width: 650px) {
    response-footer button-bar {
      margin-top: calc(1.5 * var(--rfi-gutters));
    }
  }
  @media(min-width: 1000px) {
    response-footer button-bar {
      padding: calc(0.75* var(--rfi-gutters)) var(--rfi-gutters);
      margin-top: var(--rfi-gutters);
    }
  }

  #rf-decline-button { order: 1; }
  #rf-approve-button { order: 3; }
  button-bar .crypto-info {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    flex: 1 1 auto;

    order: 4; /* on mobile, this will put it in a second row */
  }
  .crypto-info sl-button::part(base) {
    border-color: transparent;
    color: var(--gray-6);
    font-weight: 200;
  }
  .crypto-info sl-button:hover::part(base),
  .crypto-info sl-button:focus::part(base) {
    color: var(--yellow-7);
    border-color: var(--yellow-7);
    background-color: var(--yellow-2);
  }
  @media(min-width: 650px) {
    button-bar .crypto-info {
      order: 2;
    }
  }

  signature-block {
    display: flex;
    position: relative;
    gap: 1rem;
  }
  
  signature-block sl-input.signature {
    flex: 1 1 auto;
    max-width: 100%;
  }

  sl-input.signature::part(base) {
    height: 4rem;
    padding-right: 5rem;
  }
  sl-input.signature::part(input) {
    font-family: var(--signature-font);
    font-size: 1rem;
    height: 100%;
  }
  @media(min-width: 650px) {
    sl-input.signature::part(base) {
      height: 5rem;
    }
    sl-input.signature::part(input) {
      font-size: 2rem;
    }
  }

  sl-menu-item.signature::part(base) {
    font-family: var(--signature-font);
  }

  #font-dropdown {
    margin-top: 1.65rem;
    position: absolute;
    right: 1rem;
    top: 1rem;
  }

  field-pair:has(sl-checkbox) {
    align-items: flex-end;
  }

  .pdf-embed {
    position: relative;
    height: 80vh;

    border-radius: 12px;
    overflow: hidden;
    border: 1px solid var(--gray-8);
  }
  .pdf-embed embed {
    width: 100%;
    height: 100%;
  }

  code {
    word-break: break-all;
    background: var(--gray-2);
    padding: 0.2rem 0.4rem;
    border-radius: 3px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.8em;
  }

  sl-details {
    margin-top: 0.5rem;
  }

  sl-dialog p:first-child {
    margin-top: 0;
  }

  sl-dialog#key-mgmt-dialog {
    --width: 90vw;
  }
  sl-dialog#key-mgmt-dialog::part(panel) {
    max-width: 800px;
  }

`;
